export default __webpack_public_path__ + "static/ncscm-1e65bf5c1110fb571d70d3834c661191.jpg";